export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.133 2.695l.223.039.136.038c.315.101.589.286.805.422l8.646 5.46a1.002 1.002 0 01-.535 1.846h-1.5V19h2v2h-20v-2h2v-8.5h-1.5a1 1 0 01-.534-1.846l8.646-5.46c.247-.155.569-.375.941-.46.22-.051.448-.064.672-.039zM6.908 10.5V19h5v-8.5h-5zm7 0V19h5v-8.5h-5zm-1.005-5.807c-.065.035-.15.088-.315.192L6.864 8.5h12.088L13.23 4.885a6.797 6.797 0 00-.315-.192l-.006-.004-.005.004z\" fill=\"#101010\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};